exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".greyCC {\n  color: #cccccc; }\n\n.grey40 {\n  color: #404040; }\n\n.grey9b {\n  color: #9b9b9b; }\n\n.grey99 {\n  color: #999999; }\n\n.grey88 {\n  color: #888888; }\n\n.green {\n  color: #63B508; }\n\n.orange {\n  color: #FE5815; }\n\n.white-opac {\n  color: rgba(255, 251, 251, 0.6); }\n\n.white-opac3 {\n  color: rgba(255, 251, 251, 0.3); }\n\n.white-opac2 {\n  color: rgba(255, 251, 251, 0.7); }\n\n.black-opac {\n  color: rgba(0, 0, 0, 0.6); }\n\n.menu-opacity {\n  background-color: black;\n  min-height: 50px;\n  opacity: 0.2;\n  position: relative; }\n\n.menu-row {\n  position: relative;\n  top: -39px; }\n\n.ht50 {\n  height: 50px; }\n\n.menu-button {\n  float: left; }\n\n.text-orange {\n  color: #FE5815; }\n\n.brand-name {\n  font-size: 14px;\n  min-width: 70px; }\n\n.ln-feedback {\n  float: right; }\n\n.ln-feedback a {\n  color: white;\n  font-size: 13px; }\n\na.ln-feedback:focus, a.ln-feedback:visited, a.ln-feedback:active, a.ln-feedback:hover {\n  color: white;\n  text-decoration: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/angular/mobilit-web/src/app/includes/header/header.component.scss
// module id = ../../../../../src/app/includes/header/header.component.scss
// module chunks = main